// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  uid: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  rotY: __t.f32(),
  floor: __t.u32(),
  parentUid: __t.string(),
  slotIndex: __t.i32(),
  localRotY: __t.f32(),
};
